export class AuthError extends Error {
  public description: string | undefined;
  constructor(error: Error, description?: string);
  constructor(message: string, description?: string);
  constructor(messageOrError: Error | string, description?: string) {
    const message =
      messageOrError instanceof Error ? messageOrError.message : messageOrError;

    super(message);
    this.description = description;
  }
}

export class AuthExistingError extends AuthError {}
export class AuthNotFoundError extends AuthError {}
export class AuthExpiredError extends AuthError {}
export class AuthCooldownError extends AuthError {}
